import AdminLayout from "./admin.hoc";
import HomeLayout from "./home.hoc";
import HorecaLayout from "./horeca.hoc";
import ServiceLayout from "./service.hoc";
import Z2HLayout from "./z2h.hoc";

export { AdminLayout, HomeLayout, HorecaLayout, ServiceLayout, Z2HLayout };
